import { IconProps } from 'icons/Credits.icon';
import React from 'react';

const EditIcon: React.FC<IconProps> = ({ color = '#020511' }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_526_1438)">
        <path
          d="M17.6423 5.67664C18.0829 5.23616 18.3305 4.63869 18.3306 4.01568C18.3307 3.39267 18.0832 2.79515 17.6428 2.35456C17.2023 1.91396 16.6048 1.6664 15.9818 1.66632C15.3588 1.66624 14.7613 1.91366 14.3207 2.35414L3.19901 13.4783C3.00552 13.6712 2.86244 13.9087 2.78234 14.17L1.68151 17.7966C1.65997 17.8687 1.65834 17.9453 1.6768 18.0182C1.69526 18.0911 1.73311 18.1577 1.78634 18.2108C1.83957 18.264 1.90619 18.3017 1.97914 18.32C2.05209 18.3384 2.12864 18.3366 2.20067 18.315L5.82817 17.215C6.08915 17.1356 6.32665 16.9934 6.51984 16.8008L17.6423 5.67664Z"
          stroke={color}
          strokeOpacity="0.65"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 4.16669L15.8333 7.50002"
          stroke={color}
          strokeOpacity="0.65"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_526_1438">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EditIcon;
